import EmbeddedFormPage from './EmbeddedFormPage';

const WhiteLabelWebsitePage = () => (
  <EmbeddedFormPage
    titleKey="White Label Website"
    description="Fill out this form to launch your White Label Website. The White Label Website gives your program a fully branded site with your own logo, colors, and domain — powered by Wonderschool behind the scenes."
    formUrl="https://wonderschool.fillout.com/t/5b2Gn7r76dus"
  />
);

export default WhiteLabelWebsitePage;
